import React, { useState } from "react";
import {makeStyles, Box, Collapse, IconButton, Accordion, Typography} from "@material-ui/core/";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import ArrowTo from "../assets/img/arrowTo.svg";
import ManuDetails from "./ManuDetail";

const useRowStyles = makeStyles((theme) => ({
  root: {
    marginBottom: '0px',
    top: "504px",
    left: "1px",
    width: "500px",
    height: "50px",
    background: "#FCFCFC 0% 0% no-repeat padding-box",
    border: "0.5px solid #D8D8D8",
    borderRadius: "3px",
    opacity: 1,
  },
  placeText: {
    marginTop: "12px",
    marginLeft: "30px",
    
   
    height: "39px",
    textAlign: "left",
    font: "normal normal 600 20px Montserrat",
    letterSpacing: "0px",
    color: "#313131",
    opacity: 1,
  },
  destinationText: {
    marginTop: "-65px",
    marginLeft: "150px",
    paddingLeft: '10px',
    
    height: "39px",
    textAlign: "left",
    font: "normal normal 600 20px Montserrat",
    letterSpacing: "0px",
    color: "#313131",
    opacity: 1,
  },
  arrow: {
 
  
    paddingLeft: '15px',
    paddingRight: '15px',
  
    height: "15px",
    background: "transparent 0% 0% no-repeat padding-box",
    opacity: 1,
    
  },
  iconButton :{
    marginTop: "-78px",
    marginLeft: "450px",
    color: '#DC251A',
    width: "23px",
    height: "25px",
    border: "3px solid #33333",
    opacity: 1,
    '&:focus':{
        border:"none"
    }
  }
}));

const DetailTable = ({ manuscript }) => {
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();
  

  return (
    <div style={{marginBottom: '-30px', marginTop: '25px'}}>
      <Box className={classes.root}>
        <Typography className={classes.placeText} justify="center">
          {manuscript.startPoint}
        <img
          src={ArrowTo}
          className={classes.arrow}
          alt="arrow"/>
        {manuscript.endPoint}
       </Typography>
        </Box>
        
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={() => setOpen(!open)}
        >
          {open ? <KeyboardArrowUpIcon className={classes.iconButton} /> : <KeyboardArrowDownIcon className={classes.iconButton}/>}
        </IconButton>
      <br />
      <Box>
        <Box
          style={{ paddingBottom: 0, paddingTop: 0}}
          colSpan={6}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div style={{ marginLeft: '-5px' }}>
                <Accordion elevation={0} style={{ width: 500, marginBottom: 10 }}>
                  <div style={{marginTop: '-30px'}}>
                  <ManuDetails manu={manuscript} />
                  </div>
                </Accordion>
              </div>
            </Box>
          </Collapse>
        </Box>
      </Box>
    </div>
  );
};

export default DetailTable;
